/**
 * Builds a message from an axios failure.
 *
 * `error.response` is absent for network failures, timeouts and CORS errors, so
 * reading `error.response.statusText` inside a catch block throws a TypeError
 * and hides the real failure.
 *
 * A 401 always maps to "Unauthorized" because callers compare against that
 * exact string to detect an expired session, and HTTP/2 responses carry no
 * status text at all.
 */
export function getApiErrorMessage(error, fallback = "Request failed") {
  const response = error?.response;

  if (response?.status === 401) return "Unauthorized";
  if (response?.statusText) return response.statusText;
  if (response?.status) return `Request failed (${response.status})`;

  return error?.message || fallback;
}
